import {
    USER_SIGNOUT_SUCCESS,
    PUT_USER,
    SET_USER_SEARCHPARAMS,
    PUT_SYSTEM_SETTINGS,
    PUT_ACCESS_TOKEN,
} from '../actionTypes';

export const putAccessToken = (token) => {
    return {
        type: PUT_ACCESS_TOKEN,
        payload: token,
    };
};

export const putUser = (data) => {
    return {
        type: PUT_USER,
        payload: data,
    };
};

export const userSignOutSuccess = () => {
    return {
        type: USER_SIGNOUT_SUCCESS,
    };
};

export const setMemberSearchParams = (payload) => {
    return {
        type: SET_USER_SEARCHPARAMS,
        payload: payload,
    };
};

export const putSystemSettings = (payload) => {
    return {
        type: PUT_SYSTEM_SETTINGS,
        payload,
    };
};
